import React, {Fragment} from "react";
import Typography from "@material-ui/core/Typography";
import Search from "./Search";
import BackButton from "../BackButton";
import {getMessage} from "../../util";

const MeetingSearch = (props) => {
    console.log("MeetingSearch.js Init props:  ", props);
    const meeting = props.meeting;
    const messages = props.messages;

    return (
        <Fragment>
            {(meeting) ? (
                    <Fragment>
                        <BackButton meeting={meeting} messages={messages} href={"/meeting/" + meeting.slug}/>
                        <Search messages={messages} meeting={meeting}/>
                    </Fragment>
                ) : (
                    <Typography variant="h5" component="h2">
                        <hr/>
                        {getMessage('default', 'meeting_not_found', null)}
                    </Typography>
                )
            }
        </Fragment>
    );
}

export default MeetingSearch;